// src/services/apiService.js
import axios from 'axios'
import useAuthStore from '@/store/authStore.js'
// import { updateCookies } from '@/plugins/cookie-updater'
import router from '@/router'

export default {
  async sendRequestWithBearer (method, url, token, payload = null, responseType = 'json') {
    const config = {
      method: method,
      maxBodyLength: Infinity,
      url: url,
      responseType: responseType, // <--- ORA GESTISCE IL BLOB
      headers: {
        Authorization: 'Bearer ' + token
      }
    }

    if (payload != null) {
      config.data = payload
      if (!(payload instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json'
      }
    }

    try {
      const response = await axios.request(config)

      // Se abbiamo chiesto un BLOB, restituiamo tutta la risposta
      // (perché il BLOB è dentro response.data)
      if (responseType === 'blob') {
        return response
      }

      // Comportamento standard per JSON
      if (response.status === 200) {
        return response.data
      } else if (response.status === 400) {
        return { error: response.status, details: response.data }
      } else {
        throw new Error(`Richiesta fallita con stato ${response.status}`)
      }
    } catch (error) {
      const status = error.response?.status
      if (status === 401 || status === 419) {
        handleSessionExpired()
        return null
      }
      if (status === 400) {
        return { error: status, details: error.response.data }
      }
      console.error('Errore nella richiesta:', error)
      return null
    }
  },

  async getClientCredentialsToken () {
    const url = process.env.VUE_APP_URL_DOMAIN + '/ajax/auth.php'

    const params = new URLSearchParams()
    const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    params.append('session', session)
    // params.append('time', timeStamp)

    try {
      const response = await axios.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        maxBodyLength: Infinity
      })

      const status = response?.status

      if (status === 200) {
        if (response.data && response.data.access_token && response.data.response === 'OK') {
          // updateCookies()
          return response.data.access_token
        } else {
          // console.error('Errore: access_token non trovato nella risposta.')
          return null
        }
      } else {
        // console.error('Errore nella richiesta del token:', response)
        return null
      }
    } catch (error) {
      // console.error('Errore nella richiesta del token:', error)

      if (status === 401 || status === 419) {
        handleSessionExpired()
      }
      return null
      // throw error
    }
  },
  async getLoginUserToken (token, form) {
    const url = process.env.VUE_APP_URL_DOMAIN + '/ajax/auth.php'
    const params = new URLSearchParams()
    const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    params.append('session', session)
    params.append('token', token)
    params.append('_uigoru', form.username)
    params.append('_pigoru', form.password)
    params.append('rememberme', form.rememberme)

    try {
      const response = await axios.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        maxBodyLength: Infinity
      })

      const status = response?.status

      if (status === 200) {
        if (response.data && response.data.access_token && response.data.response === 'OK') {
          return response.data
        } else {
          // console.error('Errore: access_token non trovato nella risposta.')

          if (status === 401 || status === 419) {
            handleSessionExpired()
          }
          return null
        }
      } else {
        // console.error('Errore nella richiesta del token:', response)

        if (status === 401 || status === 419) {
          handleSessionExpired()
        }
        return null
      }
    } catch (error) {
      // console.error('Errore nella richiesta del token:', error)

      if (status === 401 || status === 419) {
        handleSessionExpired()
      }
      return null
      // throw error
    }
  },

  async changePassword (form) {
    const url = process.env.VUE_APP_URL_DOMAIN + '/ajax/auth.php'
    const params = new URLSearchParams()
    const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    params.append('session', session)
    params.append('newpass', form.password)
    params.append('changePassword', 1)

    try {
      const response = await axios.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        maxBodyLength: Infinity
      })

      const status = response?.status

      if (status === 200) {
        if (response.data && response.data.access_token && response.data.response === 'OK') {
          return response.data
        } else {
          if (status === 401 || status === 419) {
            handleSessionExpired()
          }
          return null
        }
      } else {
        if (status === 401 || status === 419) {
          handleSessionExpired()
        }
        return null
      }
    } catch (error) {
      if (status === 401 || status === 419) {
        handleSessionExpired()
      }
      return null
    }
  },

  async logout () {
    const url = process.env.VUE_APP_URL_DOMAIN + '/ajax/logout.php'
    try {
      const params = new URLSearchParams()
      const session = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      if (session) {
        params.append('session', session)
        await axios.post(url, params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      }
    } catch (_) {
    // ignora errori server
    }

    useAuthStore.dispatch('logout')
    localStorage.removeItem('authStore')
    localStorage.removeItem('SettingsStore')
    localStorage.removeItem('listitem')
    localStorage.removeItem('activeTableInfo')
    localStorage.removeItem('activeTableSchema')

    return true
  }

}

function handleSessionExpired () {
  // evita loop
  if (router.currentRoute.name !== 'login') {
    const url = process.env.VUE_APP_URL_DOMAIN + '/ajax/logout.php'
    try {
      const params = new URLSearchParams()
      const session = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      if (session) {
        params.append('session', session)
        axios.post(url, params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      }
    } catch (_) {
    // ignora errori server
    }

    useAuthStore.dispatch('logout')
    localStorage.removeItem('authStore')
    localStorage.removeItem('SettingsStore')
    localStorage.removeItem('listitem')

    return true
  }
}
